import React, { useEffect, useState } from 'react';
import { Table, Input, Space, Typography, Button } from 'antd';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;
const { Search } = Input;

const Logs = () => {
    const [data, setData] = useState([]); // Store fetched data
    const [filteredData, setFilteredData] = useState([]); // For search functionality
    const navigate = useNavigate();

    // Fetch dashboard data
    const getToken = () => {
        const value = `; ${document.cookie}`;
        const parts = value.split('; token=');
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    };

    const fetchData = async () => {
        try {
            const token = getToken();
            const response = await api.get('/download-logs', {
                headers: { Authorization: `Bearer ${token}` },
            });
            setData(response.data);
            setFilteredData(response.data); // Initialize filtered data
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            alert('Session expired. Redirecting to login.');
            navigate('/'); // Redirect to login
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Search functionality
    const onSearch = (value) => {
        const filtered = data.filter((user) =>
            user.email.toLowerCase().includes(value.toLowerCase()) ||
            user.username.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredData(filtered);
    };

    // Table columns
    const columns = [
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Product ID',
            dataIndex: 'productID',
            key: 'productID',
        },
        {
            title: 'Version',
            dataIndex: 'version',
            key: 'version',
        },
        {
            title: 'Subscription ID',
            dataIndex: 'subscriptionID',
            key: 'subscriptionID',
        },
        {
            title: 'Download Date',
            dataIndex: 'downloadDate',
            key: 'downloadDate',
            render: (date) => new Date(date).toLocaleString(),
        },
    ];

    return (
        <div style={{ padding: '20px' }}>
            <Title level={2}>Download Logs</Title>
            <Button onClick={() => navigate('/dashboard')}>
                Dashboard
            </Button>
            <br />
            <Space style={{ marginBottom: '20px' }}>
                <Search
                    placeholder="Search by username or email"
                    onSearch={onSearch}
                    enterButton
                    style={{ width: 300 }}
                />
            </Space>
            <Table
                columns={columns}
                dataSource={filteredData}
                rowKey="_id"
                pagination={{ pageSize: 10 }}
            />
        </div>
    );
};

export default Logs;
